import systemSearch from './search';

export default {
  systemSearch,
};
